import React, { Component } from 'react';
import { Row, Icon } from 'react-materialize';
import { connect } from 'react-redux';


class CloseCollapsible extends Component {
  showCountries(countries){
    var return_countries_array = [];
    if (countries.length > 10){
      for(let i = 0; i < 10; i++){
          return_countries_array.push(<span class="collapsed-input">{countries[i]}</span>)
      }
      return_countries_array.push("...")
    } else {
      for(let i = 0; i < countries.length; i++){
          return_countries_array.push(<span class="collapsed-input">{countries[i]}</span>)
      }
    }

    return return_countries_array;
    //return countries.map(country => <span class="collapsed-input">{country}</span>)
  }
  render() {
    const { onClickCollapsible = ()  => {}, gender, countries, yearBound, age } = this.props;
    return (
      <div className="CloseCollapsible">
        <Row style={{paddingLeft: "6vw"}}>
          <span class="collapsed-label">Gender</span>
          {gender.map(gender => <span class="collapsed-input">{gender}</span>)}
          <span>\</span>
          <span class="collapsed-label">Age</span>
          {age.map(age => <span class="collapsed-input">{age}&nbsp;</span>)}

          <span>\</span>
          <span class="collapsed-label">Year Range</span>
          <span class="collapsed-input">{yearBound[0]} - {yearBound[1]}</span>
          <span>\</span>
          <span class="collapsed-label">Selected Countries</span>
          {
            this.showCountries(countries)
          }
        </Row><br/>
        <div class="collape">
          <div className="rectangle" onClick={onClickCollapsible}>
            <Icon>keyboard_arrow_down</Icon>
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state){
  return {
    countries: state.countries,
    gender: state.gender,
    age: state.age,
    yearBound: state.yearBound
  }
};

function mapDispatchToProps(dispatch){
  return {
  //  changeNoteText: (text) => dispatch({ type: 'CHANGENOTETEXT', value: text }),
  //  addNotes: () => dispatch({ type: 'ADDNOTES' }),
  //  addPhotos: (photos) => dispatch({ type: 'ADDPHOTOS', value: photos})
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CloseCollapsible);



// WEBPACK FOOTER //
// ./src/components/CloseCollapsible.js